// ServicePhaseTwo.js
import React from 'react';
import { FaEye, FaBullseye, FaHandsHelping, FaQuoteLeft } from 'react-icons/fa';
import './ServicePhaseTwo.css';

function ServicePhaseTwo() {
  const coreValues = [
    {
      icon: <FaEye size={50} color="#0d6efd" />,
      title: "Vision",
      desc: "To be a trusted partner recognized for delivering insightful, transparent, and value-driven financial and consulting solutions that empower businesses to thrive and grow."
    },
    {
      icon: <FaBullseye size={50} color="#198754" />,
      title: "Mission",
      desc: "Deliver precise, ethical, and personalized auditing and consulting services that help clients succeed."
    },
    {
      icon: <FaHandsHelping size={50} color="#ffc107" />,
      title: "Belief",
      desc: "Integrity, quality, collaboration, innovation, and growth guide everything we do."
    },
   {
  icon: <FaQuoteLeft size={50} color="#dc3545" />,
  title: "Philosophy",
  desc: `“We shape our buildings; thereafter they shape us.” <br />— Winston Churchill`
}
  ];

  return (
    <div className="phase-two-area tmp-section-gap bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
  <div className="section-head">
    <div className="section-sub-title color-secondary center-title">
      <span>OUR VALUE</span>
    </div>
    <h2 className="section-title split-collab">Vision, Mission & Core Beliefs</h2>
  </div>
</div>
        </div>

        <div className="row">
  {coreValues.map((item, idx) => (
    <div key={idx} className="col-lg-3 col-md-6 col-sm-12">
      <div className={`core-box core-box-${idx + 1}`}>
        <div className="icon mb-2">{item.icon}</div>
        <h3 className="core-title">{item.title}</h3>
        <p
          className="description"
          dangerouslySetInnerHTML={{ __html: item.desc }}
          style={{ textAlign: "justify" }}
        />
      </div>
    </div>
  ))}
</div>
      </div>
    </div>
  );
}

export default ServicePhaseTwo;
